// The portal's landing route, honouring the org's nav selection.
//
// `/members` is where login drops every member, so an org that hides Home in
// Portal settings would otherwise land its people on the one page it took out
// of the nav. Redirect to the first destination that org does show instead.
//
// Rendered in place of Home on the landing routes only — deep links into a
// hidden section (a task link from a notification email, say) keep working, so
// hiding a nav item tidies the nav without breaking anyone's existing links.

import { Navigate } from "react-router-dom";
import { DESKTOP_NAV } from "components/nav/navConfig";
import { hiddenHomeRedirectPath } from "components/nav/navVisibility";
import MFMembers from "state/members/membersState";
import Home from "./Home";

const HomeOrFirstNav = () => {
  const config = MFMembers.useGetPortalConfig();
  const redirectTo = hiddenHomeRedirectPath(DESKTOP_NAV, config?.navItems);

  // `replace` so the hidden landing route never becomes a back-button trap.
  if (redirectTo) return <Navigate to={redirectTo} replace />;

  return <Home />;
};

export default HomeOrFirstNav;
